interface SchemaLoaderProps {
    schema:any
}

const SchemaLoader = (props: SchemaLoaderProps) => {
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(props.schema) }} />
}

export default SchemaLoader;